import React from 'react';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { IndentContainer, withRadius } from '@r1-frontend/ui-react/experimental/containers';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { ImageBlock, Wrapper } from './styled';

const RulesBannerBlock = ({ ...props }): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return (
        <Wrapper {...props} bgImage={'/static/images/tariff-builder/clouds.png'} bgWebpImage={'/static/images/tariff-builder/clouds.webp'}>
            <IndentContainer $desktop={[24, 0, 24, 24]} $mobile={[0, 0, 0, 12]}>
                <p>
                    Выбирайте и&nbsp;платите только за&nbsp;те&nbsp;услуги, которые вам нужны.
                    Чем больше услуг, тем выгоднее тариф
                </p>
            </IndentContainer>
            {isMobile
                ? <WebpImage urlWebp={'/static/images/tariff-builder/banner-mobile.webp'}>
                    <ImageBlock src={'/static/images/tariff-builder/banner-mobile.png'}/>
                </WebpImage>
                : <WebpImage urlWebp={'/static/images/tariff-builder/banner.webp'}>
                    <ImageBlock src={'/static/images/tariff-builder/banner.png'}/>
                </WebpImage>
            }
        </Wrapper>
    );
};

export default withRadius(RulesBannerBlock, { $desktop: 32, $mobile: 24 });
